import React, { useState, useEffect } from "react";

const PhoneModal = ({ open, initialPhone = "", onClose, onConfirm }) => {
  const [phone, setPhone] = useState(initialPhone);

  // initialPhone이 바뀌면 동기화
  useEffect(() => {
    setPhone(initialPhone);
  }, [initialPhone]);

  if (!open) return null;

  const handleConfirm = () => {
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length !== 11) {
      alert("휴대폰 번호를 정확히 입력해주세요.");
      return;
    }
    onConfirm(cleaned);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 ">
      <div className="bg-white rounded-xl w-[90vw] max-w-sm px-2 py-6 relative flex flex-col justify-between min-h-[80vh]">
        <div className="flex justify-center mb-6 mt-12">
          <img
            src="/assets/mobile.png"
            alt="전화 아이콘"
            className="w-[16vw] max-w-[60px] h-auto"
          />
        </div>

        <div className="text-center text-lg font-semibold mb-8 space-y-1">
          <div>실시간 매출 분석 데이터 결과를</div>
          <div>받을 휴대폰 번호를 입력해 주세요.</div>
        </div>

        <div className="font-semibold mb-8">
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="예: 01012345679"
            className="w-[90%] pb-2 mx-6 text-xl outline-none border-b border-gray-300 "
          />
        </div>

        {/* 하단 버튼들 */}
        <div className="flex justify-between text-[5vw] mt-auto">
          <button
            onClick={onClose}
            className="flex-1 text-neutral-500 text-center font-bold"
          >
            취소
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 text-blue-600 text-center font-bold"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhoneModal;
